import React from 'react';
import { Tooltip } from 'antd';
import InfoIcon from '../../assets/images/newImages/info-icon-blue.svg';

/*
 * Reserved Stock cell: units allocated to an Amazon shipment but not yet counted in Amazon Total —
 * still physically in the warehouse for a Pack Now plan pre-placement, plus Amazon's own
 * inboundWorkingQuantity (moved out of Amazon Total to avoid double-counting). Hover the info icon
 * for the breakdown; both numbers are already on the row, so no extra fetch is needed (unlike
 * PoBreakdownIcon's on-click PO-line-item lookup).
 * Drop-in on any page (SKU, Products, Database, Catalog): {value}{internal}{amazonInboundWorking}.
 */
const ReservedStockCell = ({ value, internal, amazonInboundWorking, size = 13 }) => {
  const total = Number(value) || 0;
  const internalQty = Number(internal) || 0;
  const amazonQty = Number(amazonInboundWorking) || 0;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      {total}
      {total > 0 && (
        <Tooltip
          title={
            <div>
              <div>Warehouse Reserved: {internalQty}</div>
              <div>Amazon Inbound Working: {amazonQty}</div>
            </div>
          }
        >
          <img
            src={InfoIcon}
            alt="breakdown"
            style={{ width: size, height: size, cursor: 'pointer', marginLeft: 6, verticalAlign: 'middle' }}
          />
        </Tooltip>
      )}
    </span>
  );
};

export default ReservedStockCell;
